import { ProductGrid } from "./ProductGrid";
import { CategoryShowcaseGrid } from "./CategoryShowcaseGrid";
import { PromoCardsRow } from "./PromoCardsRow";
import { ProductShowcaseSection } from "./ProductShowcaseSection";
import { FeaturedCardsRow } from "./FeaturedCardsRow";
import { FlashDealsSection } from "./FlashDealsSection";
import { PromoBannerSection } from "./PromoBannerSection";

const LEGACY_PRODUCT_TYPES = new Set([
  "category",
  "brand",
  "bestseller",
  "new_arrivals",
  "product_showcase",
]);

export function normalizeSectionType(sectionType) {
  if (sectionType === "offers_grid") return "promo_row";
  return sectionType;
}

export function HomeSectionRenderer({ section }) {
  if (!section) return null;

  const type = normalizeSectionType(section.sectionType);

  if (LEGACY_PRODUCT_TYPES.has(type)) {
    return <ProductShowcaseSection section={section} />;
  }

  switch (type) {
    case "category_grid":
      return <CategoryShowcaseGrid section={section} />;

    case "promo_row":
      return <PromoCardsRow section={section} />;

    case "featured_cards":
      return <FeaturedCardsRow section={section} />;

    case "product_grid_tabs":
      return <ProductGrid section={{ ...section, tabs: section.tabs || [] }} />;

    case "flash_deals":
      return <FlashDealsSection section={section} />;

    case "promo_banner":
      return <PromoBannerSection section={section} />;

    default:
      return null;
  }
}
